module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit()
      }
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col-lg-12 tp15"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "centerDiv"
  }, [_c('span', {
    staticClass: "uploadTxt"
  }, [_vm._v(_vm._s(_vm.$t("message.upload_page.upload_txt")))]), _vm._v(" "), _c('span', {
    staticClass: "metadataTxt inprogressTxt"
  }, [_vm._v(_vm._s(_vm.$t("message.upload_page.metadata_txt")))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 tp15"
  }, [_c('span', {
    staticClass: "filesAndFoldersTxt"
  }, [_vm._v(_vm._s(_vm.$t("message.upload_page.metadata_txt")))]), _vm._v(" "), _c('span', {
    staticClass: "fltRight"
  }, [_c('button', {
    staticClass: "completeTask nextPosition",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.$t("message.metadata_page.submit_btn")))])])]), _vm._v(" "), _c('div', {
    staticClass: "metadataHolder col-lg-12 tp15"
  }, [(this.model.dispMetadataFlag === 0) ? _c('div', {
    staticClass: "nometadataMessage"
  }, [_vm._v("You are not required to provide any Metadata updates here! Please proceed to Submit ")]) : _vm._e(), _vm._v(" "), (this.model.dispMetadataFlag === 1) ? _c('div', {
    staticClass: "metaDetails"
  }, [_c('span', {
    staticClass: "markedMandatory"
  }, [_c('span', {
    staticClass: "star"
  }, [_vm._v("*")]), _vm._v(_vm._s(_vm.$t("message.metadata_page.mandatory_txt")))]), _vm._v(" "), _vm._l((_vm.model.dynamicUiData), function(component) {
    return _c('div', {
      staticClass: "mg-top-50"
    }, [(component.displayType == 'textfield') ? _c('div', {
      staticClass: "inputHolder",
      attrs: {
        "id": component.key
      }
    }, [_c('span', {
      staticClass: "formKey"
    }, [_vm._v(_vm._s(component.displayname)), (component.required === 1) ? _c('span', {
      staticClass: "star"
    }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form[component.key]),
        expression: "form[component.key]"
      }],
      staticClass: "textfield",
      attrs: {
        "type": "text",
        "disabled": !component.iseditable,
        "name": component.propertyName
      },
      domProps: {
        "value": (_vm.form[component.key])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.form, component.key, $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "validationMessage"
    }, [_vm._v(_vm._s(_vm.errorMsg[component.key]))])]) : _vm._e(), _vm._v(" "), (component.displayType == 'textarea') ? _c('div', {
      staticClass: "inputHolder",
      attrs: {
        "id": component.key
      }
    }, [_c('span', {
      staticClass: "formKey"
    }, [_vm._v(_vm._s(component.displayname)), (component.required === 1) ? _c('span', {
      staticClass: "star"
    }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form[component.key]),
        expression: "form[component.key]"
      }],
      staticClass: "textfield",
      attrs: {
        "rows": "3",
        "disabled": !component.iseditable,
        "name": component.propertyName
      },
      domProps: {
        "value": (_vm.form[component.key])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.form, component.key, $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "validationMessage"
    }, [_vm._v(_vm._s(_vm.errorMsg[component.key]))])]) : _vm._e(), _vm._v(" "), (component.displayType == 'combobox') ? _c('div', {
      staticClass: "inputHolder",
      attrs: {
        "id": component.key
      }
    }, [_c('span', {
      staticClass: "formKey"
    }, [_vm._v(_vm._s(component.displayname)), (component.required === 1) ? _c('span', {
      staticClass: "star"
    }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form[component.key]),
        expression: "form[component.key]"
      }],
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.form, component.key, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((component.listvalues), function(listvalue) {
      return _c('option', {
        domProps: {
          "value": listvalue.key
        }
      }, [_vm._v(_vm._s(listvalue.displayname))])
    }), 0), _vm._v(" "), _c('span', {
      staticClass: "validationMessage"
    }, [_vm._v(_vm._s(_vm.errorMsg[component.key]))])]) : _vm._e(), _vm._v(" "), (component.displayType == 'datefield') ? _c('div', {
      staticClass: "inputHolder",
      attrs: {
        "id": component.key
      }
    }, [_c('span', {
      staticClass: "formKey"
    }, [_vm._v(_vm._s(component.displayname)), (component.required === 1) ? _c('span', {
      staticClass: "star"
    }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form[component.key]),
        expression: "form[component.key]"
      }],
      staticClass: "textfield",
      attrs: {
        "type": "date",
        "name": component.propertyName
      },
      domProps: {
        "value": (_vm.form[component.key])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.form, component.key, $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "validationMessage"
    }, [_vm._v(_vm._s(_vm.errorMsg[component.key]))])]) : _vm._e(), _vm._v(" "), (component.displayType == 'checkbox') ? _c('div', {
      staticClass: "inputHolder",
      attrs: {
        "id": component.key
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form[component.key]),
        expression: "form[component.key]"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(_vm.form[component.key]) ? _vm._i(_vm.form[component.key], null) > -1 : (_vm.form[component.key])
      },
      on: {
        "change": function($event) {
          var $$a = _vm.form[component.key],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.form, component.key, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.form, component.key, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.form, component.key, $$c)
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "checkKey"
    }, [_vm._v(_vm._s(component.displayname))]), _vm._v(" "), _c('div', {
      staticClass: "validationMessage"
    }, [_vm._v(_vm._s(_vm.errorMsg[component.key]))])]) : _vm._e(), _vm._v(" "), (component.displayType == 'number') ? _c('div', {
      staticClass: "inputHolder",
      attrs: {
        "id": component.key
      }
    }, [_c('span', {
      staticClass: "formKey"
    }, [_vm._v(_vm._s(component.displayname)), (component.required === 1) ? _c('span', {
      staticClass: "star"
    }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form[component.key]),
        expression: "form[component.key]"
      }],
      staticClass: "textfield",
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (_vm.form[component.key])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.form, component.key, $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "validationMessage"
    }, [_vm._v(_vm._s(_vm.errorMsg[component.key]))])]) : _vm._e()])
  })], 2) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "middleHolder"
  }, [_c('span', {
    staticClass: "completedTask"
  }, [_c('i', {
    staticClass: "tickMark fa fa-check"
  })]), _vm._v(" "), _c('span', {
    staticClass: "connectingLine inprogress"
  }), _vm._v(" "), _c('span', {
    staticClass: "pendingTask inprogress"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8d03914a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Admin/Metadata.vue
// module id = 164
// module chunks = 1